import React from "react";
import AppleLocalNav from "../../AppleLocalNav";
export default function GiftSubNav(){return <AppleLocalNav title="Ways to Give" overview="/ways-to-give" overviewLabel="Ways to Give" pages={[{label:"Being a Volunteer",to:"/being-a-volunteer"},{label:"Donate",to:"/donate"}]} />;}
